<template>
  <OverlayButton
    :disabled="isDisabled"
    @click="$emit('click')"
  >
    <template v-if="isLoading">
      <VsIcon icon="md:sync" />&nbsp;<span class="align-middle"><slot name="loading" /></span>
    </template>
    <template v-else-if="error">
      <VsIcon icon="md:error_outline" />&nbsp;<span class="align-middle"><slot name="error">{{ error.message }}</slot></span>
    </template>
    <span v-else>
      <slot />
    </span>
  </OverlayButton>
</template>

<script lang="ts">
import Vue from 'vue';
import VsIcon from '@/scripts/Components/Molecules/VsIcon.vue';
import OverlayButton from '../../components/OverlayButton.ts.vue';

export default Vue.extend({
  components: {
    OverlayButton,
    VsIcon,
  },

  props: {
    error: {
      type: Error,
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isDisabled(): boolean {
      return this.disabled || this.isLoading;
    },
  },
});
</script>
